import {
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DescriptionIcon from "@mui/icons-material/Description";
import StorageIcon from "@mui/icons-material/Storage";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

import SummarizeIcon from "@mui/icons-material/Summarize";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import Collapse from "@mui/material/Collapse";
import "../assets/css/style.css";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import AnalyticsIcon from "@mui/icons-material/Analytics";

// employees menu icons
import BadgeIcon from "@mui/icons-material/Badge";
import TodayIcon from "@mui/icons-material/Today";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import EventBusyIcon from "@mui/icons-material/EventBusy";
// purchase order menu icons
import ShoppingCartRounded from "@mui/icons-material/ShoppingCartRounded";
import ListAltRounded from "@mui/icons-material/ListAltRounded";
import NoteAddRounded from "@mui/icons-material/NoteAddRounded";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
//Invoices menu icons
import ReceiptLongRounded from "@mui/icons-material/ReceiptLongRounded";
// Masters menu icons
import GroupRounded from "@mui/icons-material/GroupRounded";
import StorefrontRounded from "@mui/icons-material/StorefrontRounded";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import InventoryRounded from "@mui/icons-material/InventoryRounded";
// configuration menu icons
import SettingsRounded from "@mui/icons-material/SettingsRounded";
import BusinessIcon from "@mui/icons-material/Business";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaidIcon from "@mui/icons-material/Paid";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
// report menu icons
import SummarizeRounded from "@mui/icons-material/SummarizeRounded";
import TimelineRounded from "@mui/icons-material/TimelineRounded";
import PaymentIcon from "@mui/icons-material/Payment";
import BeachAccessRounded from "@mui/icons-material/BeachAccessRounded";
import PunchClockRounded from "@mui/icons-material/PunchClockRounded";
import TrackChangesRounded from "@mui/icons-material/TrackChangesRounded";
import RequestQuoteRounded from "@mui/icons-material/RequestQuoteRounded";
import HowToRegRounded from "@mui/icons-material/HowToRegRounded";

import Tooltip from "@mui/material/Tooltip";

import axios from "axios";
import { menuPermissionsAPI, config } from "../config";

function Sidenav({ isSidebarOpen }) {
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const activeUrl = window.location.pathname;
  const [generalMenu, setGeneralMenu] = useState([]);
  const [MenuManagement, setmenuManagement] = useState([]);
  const [UserMenu, setuserMenu] = useState([]);
  const useRefApp = useRef(false);
  const userData = JSON.parse(localStorage.getItem("user")) || {};

  // const handleClick = (id) => {
  //   if (selectedIndex === id) {
  //     setSelectedIndex("");
  //   } else {
  //     setSelectedIndex(id);
  //   }
  // };

  const handleClick = (index) => {
    setSelectedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const findIndex = (arr, path, parentKey) => {
    let foundIndex = -1;

    arr.forEach((item, index) => {
      if (item.url === path) {
        foundIndex = index;
      } else if (item.childMenu) {
        item.childMenu.forEach((childItem) => {
          if (childItem.url === path) {
            if (parentKey) {
              if (item.key === parentKey) {
                foundIndex = index;
              }
            } else {
              // Default to matching the first occurrence instead of last
              if (foundIndex === -1) {
                foundIndex = index;
              }
            }
          }
        });
      }
    });

    if (foundIndex !== -1) {
      return foundIndex + 1; // Offset for generalMenu (Dashboard)
    }
    return -1;
  };

  const isSubmenuActive = (parentMenu, submenuItem) => {
    if (activeUrl !== submenuItem.url) return false;

    // If we have a state indicating which parent was clicked, use it
    if (location.state?.parentKey) {
      return parentMenu.key === location.state.parentKey;
    }

    // Otherwise, default to matching the first parent menu that contains this URL
    const firstMatchedParent = MenuManagement.find(menu =>
      menu.childMenu?.some(sub => sub.url === activeUrl)
    );
    return firstMatchedParent ? firstMatchedParent.key === parentMenu.key : true;
  };

  useEffect(() => {
    if (useRefApp.current === false) {
      setGeneralMenu([
        {
          title: "HR Dashboard",
          url: "/dashboard",
          icon: <DonutSmallIcon />,
          childMenuFlag: false,
          key: "dashboard",
        },
        {
          title: "PO & WO Dashboard",
          url: "/purchase-work-order-dashboard",
          icon: <AnalyticsIcon />,
          childMenuFlag: false,
          key: "po_wo_dashboard",
        },
      ]);

      // setuserMenu([
      //   {
      //     title: "Attendance",
      //     url: "/user/attendance",
      //     childMenuFlag: false,
      //     key: "user_attendance",
      //   },
      //   {
      //     title: "Apply Leave",
      //     url: "/user/apply-leave",
      //     childMenuFlag: false,
      //     key: "user_apply_leave",
      //   },
      //   {
      //     title: "Labour Attendance",
      //     url: "/user/labour-attend",
      //     childMenuFlag: false,
      //     key: "user_labour_attendance",
      //   },
      // ]);

      const variable = [
        {
          title: "HR Management",
          url: "#",
          icon: <ManageAccountsIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          key: "hr_management",
          childMenu: [
            { icon: <BadgeIcon />, title: "Employees", url: "/employee/list", key: "employees" },
            {
              icon: <TodayIcon />,
              title: "Employee Attendance",
              url: "/employee-attendance",
              key: "employee_attendance",
            },
            {
              icon: <RequestPageIcon />,
              title: "Payroll Process",
              url: "/payroll-process",
              key: "payroll_process",
            },
            {
              icon: <RequestQuoteIcon />,
              title: "PaySlip Report",
              url: "/payslip-report",
              key: "payslip_report",
            },
            {
              icon: <CardGiftcardIcon />,
              title: "Yearly Bonus",
              url: "/yearly-bonus",
              key: "yearly_bonus",
            },
            {
              icon: <EventBusyIcon />,
              title: "Leave Approval",
              url: "/Leave/approval",
              key: "leave_approval",
            },
            {
              icon: <RequestQuoteRounded />,
              title: "Advance Payment Report",
              url: "/advance-payment/list",
              key: "advance_payment_report",
            },
          ],
        },
        {
          title: "Purchase Order",
          url: "#",
          icon: <DescriptionIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <ShoppingCartRounded />,
              title: "Purchase Order",
              url: "/purchase-order/create",
              key: "purchase_order_create",
            },
            {
              icon: <ListAltRounded />,
              title: "List Purchase Order",
              url: "/purchase-order/list",
              key: "purchase_order_list",
            },
            // {
            //   icon: <ListAltRounded />,
            //   title: "Material Receipt",
            //   url: "/material-receipt/list",
            //   key: "material_receipt_list",
            // },
            {
              icon: <NoteAddRounded />,
              title: "P.O Add Terms & Conditions",
              url: "/termsandconditions/add",
              key: "po_add_terms",
            },
            {
              icon: <DescriptionRounded />,
              title: "P.O List Terms & Conditions",
              url: "/termsandconditions/list",
              key: "po_list_terms",
            },
          ],
        },
        {
          title: "Invoice",
          url: "#",
          icon: <DescriptionIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <ReceiptLongRounded />,
              title: "Create Invoice",
              url: "/invoice/create",
              key: "invoice_create",
            },
            {
              icon: <ListAltRounded />,
              title: "Invoice List",
              url: "/invoice/list",
              key: "invoice_list",
            },
            {
              icon: <NoteAddRounded />,
              title: "Invoice Add Terms & Conditions",
              url: "/invoiceTermsAndConditions/add",
              key: "invoice_add_terms",
            },
            {
              icon: <DescriptionRounded />,
              title: "Invoice List Terms & Conditions",
              url: "/invoiceTermsAndConditions/list",
              key: "invoice_list_terms",
            },
          ],
        },
        {
          title: "Masters",
          url: "#",
          icon: <StorageIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            { icon: <GroupRounded />, title: "Clients", url: "/client/list", key: "clients" },
            {
              icon: <WorkOutlineIcon />,
              title: "Projects",
              url: "/project/list",
              key: "projects",
            },
            {
              icon: <StoreMallDirectoryIcon />,
              title: "Store",
              url: "/store/list",
              key: "store",
            },
            {
              icon: <StorefrontRounded />,
              title: "Vendor",
              url: "/vendor/list",
              key: "vendor",
            },
            {
              icon: <InventoryRounded />,
              title: "Payment Request",
              url: "/payment-request/list",
              key: "payment_requests",
            },
          ],
        },
        {
          title: "Configurations",
          url: "#",
          icon: <ToggleOnIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <SettingsRounded />,
              title: "Configuration",
              url: "/config/configuration",
              key: "configuration",
            },
            {
              icon: <BusinessIcon />,
              title: "Manage Departments",
              url: "/config/departments-master",
              key: "departments",
            },
            {
              icon: <WorkOutlineIcon />,
              title: "Manage Positions",
              url: "/config/positions-master",
              key: "positions",
            },
            {
              icon: <AttachMoneyIcon />,
              title: "Manage Allowances",
              url: "/manage-allowances",
              key: "allowances",
            },
            {
              icon: <SettingsRounded />, // placeholder/default icon
              title: "Manage Holidays",
              url: "/add-holiday",
              key: "holidays",
            },
            {
              icon: <BusinessIcon />,
              title: "Manage Companies",
              url: "/manage-companies/list",
              key: "companies",
            },
            {
              icon: <PaidIcon />,
              title: "Manage Labour Wages",
              url: "/config/labour-wages",
              key: "labour_wages",
            },
          ],
        },
        {
          title: "Accounting",
          url: "#",
          icon: <AttachMoneyIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          key: "accounting",
          childMenu: [
            {
              icon: <PaymentIcon />,
              title: "Project Payment Report",
              url: "/reports/project-payment-report",
              key: "project_payment_report",
            },
            {
              icon: <AttachMoneyIcon />,
              title: "Employee Payment Report",
              url: "/payment/list",
              key: "employee_payment_report",
            },
            {
              icon: <RequestQuoteRounded />,
              title: "Advance Payment Report",
              url: "/advance-payment/list",
              key: "advance_payment_report",
            },
            {
              title: "Weekly Payment Report",
              url: "/weeklyReport",
              icon: <PunchClockRounded />,
              key: "weekly_payment_report",
            },
            {
              title: "Cash in Hand",
              url: "/cash-in-hand",
              icon: <AttachMoneyIcon />,
              key: "cash_in_hand",
            },
          ],
        },
        {
          title: "Labour Attendance",
          url: "#",
          icon: <PunchClockRounded />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              title: "Site Engineer Weekly Sheet",
              url: "/weekly-labour-sheet",
              icon: <PunchClockRounded />,
              key: "site_engineer_weekly_sheet",
            },
          ],
        },
        {
          title: "Settings",
          url: "#",
          icon: <SettingsRounded />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              title: "Labour Approvals",
              url: "/labour-approver-settings",
              icon: <HowToRegRounded />,
              key: "labour_approvals",
            },
            {
              title: "Advance Relief Approver",
              url: "/advance-relief-approver-settings",
              icon: <HowToRegRounded />,
              key: "advance_relief_approver",
            },
            {
              title: "Payment Approver",
              url: "/payment-approver-settings",
              icon: <HowToRegRounded />,
              key: "payment_approver",
            },
            {
              title: "Role Menu Permissions",
              url: "/config/role-menu-settings",
              icon: <SettingsRounded />,
              key: "role_menu_permissions",
            },
          ],
        },
        // Reports Menu
        {
          title: "Reports",
          url: "#",
          icon: <SummarizeIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <SummarizeRounded />,
              title: "Project Summary Report",
              url: "/reports/project-summary",
              key: "project_summary_report",
            },
            {
              icon: <TimelineRounded />,
              title: "Project Timeline Report",
              url: "/reports/project-report",
              key: "project_timeline_report",
            },
            {
              icon: <TrackChangesRounded />,
              title: "Employee Activity Report",
              url: "/reports/employee-activity-report",
              key: "employee_activity_report",
            },
            {
              icon: <HowToRegRounded />,
              title: "Employee Attendance Report",
              url: "/reports/employee-attendance-report",
              key: "employee_attendance_report",
            },
            {
              icon: <BeachAccessRounded />,
              title: "Leave Report",
              url: "/reports/leave-report",
              key: "leave_report",
            },
            {
              icon: <PunchClockRounded />,
              title: "Labour Attendance Report",
              url: "/user/labour-attend",
              key: "labour_attendance_report",
            },
            {
              title: "Weekly Plan Schedule",
              url: "/weeklyPlanSchedule",
              icon: <PunchClockRounded />,
              key: "weekly_plan_schedule",
            },
          ],
        },
        {
          title: "Announcement",
          url: "/announcement",
          icon: <CampaignRoundedIcon />,
          childMenuFlag: false,
        },
      ];

      const isSuperAdmin = userData?.role_id == 34;
      const positionId = userData?.position || userData?.txtPosition;

      const applyPermissions = (userPerms) => {
        // Filter generalMenu
        const defaultGeneral = [
          {
            title: "Dashboard",
            url: "/dashboard",
            icon: <DonutSmallIcon />,
            childMenuFlag: false,
            key: "dashboard",
          },
          {
            title: "PO & WO Dashboard",
            url: "/purchase-work-order-dashboard",
            icon: <AnalyticsIcon />,
            childMenuFlag: false,
            key: "po_wo_dashboard",
          },
        ];
        const filteredGeneral = defaultGeneral.filter(menu => {
          if (isSuperAdmin) return true;
          const perm = userPerms.find((p) => p.submenu_key === menu.key);
          return perm ? perm.can_view === 1 : false;
        });
        setGeneralMenu(filteredGeneral);

        // Filter UserMenu
        const defaultUser = [
          {
            title: "Attendance",
            url: "/user/attendance",
            childMenuFlag: false,
            key: "user_attendance",
          },
          {
            title: "Apply Leave",
            url: "/user/apply-leave",
            childMenuFlag: false,
            key: "user_apply_leave",
          },
          {
            title: "Labour Attendance",
            url: "/user/labour-attend",
            childMenuFlag: false,
            key: "user_labour_attendance",
          },
        ];
        const filteredUser = defaultUser.filter(menu => {
          if (isSuperAdmin) return true;
          const perm = userPerms.find((p) => p.submenu_key === menu.key);
          return perm ? perm.can_view === 1 : false;
        });
        setuserMenu(filteredUser);

        const filteredVariable = variable
          .map((menu) => {
            if (menu.childMenuFlag) {
              const filteredChildren = menu.childMenu.filter((submenu) => {
                if (isSuperAdmin) return true;
                const perm = userPerms.find((p) => p.submenu_key === submenu.key);
                return perm ? perm.can_view === 1 : false;
              });
              return {
                ...menu,
                childMenu: filteredChildren,
              };
            }
            return menu;
          })
          .filter((menu) => {
            if (menu.childMenuFlag) {
              return menu.childMenu.length > 0;
            }
            return true;
          });

        setmenuManagement(filteredVariable);
        const pathname = window.location.pathname;
        const idx = findIndex(filteredVariable, pathname, location.state?.parentKey);
        setSelectedIndex(idx);
      };

      if (!isSuperAdmin && positionId) {
        axios.get(`${menuPermissionsAPI}/by-position/${positionId}`, {
          headers: config.headers,
        })
          .then((response) => {
            applyPermissions(response.data.result || []);
          })
          .catch((error) => {
            console.error("Failed to load side menu permissions:", error);
            applyPermissions([]);
          });
      } else {
        applyPermissions([]);
      }
    }
    return () => {
      useRefApp.current = true;
    };
  }, []);

  useEffect(() => { }, [isSidebarOpen]);

  return (
    <>
      {userData.role_id === 35 || userData.role_id === 34 || MenuManagement.length > 0 ? (
        <>
          {/* ── generalMenu (Dashboard only usually) ── */}
          <Grid>
            {generalMenu.map((row, index) => (
              <React.Fragment key={index}>
                {row.childMenuFlag ? (
                  <>
                    <ListItemButton
                      className="menu_id"
                      onClick={() => handleClick(index)}
                      sx={{
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        px: isSidebarOpen ? 2.5 : 0,
                        minHeight: 48,
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <>
                          <ListItemText
                            primary={row.title}
                            sx={{ whiteSpace: "nowrap" }}
                          />
                          {index === selectedIndex ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </>
                      )}
                    </ListItemButton>
                    {isSidebarOpen && (
                      <Collapse
                        in={index === selectedIndex}
                        timeout="auto"
                        unmountOnExit
                        className="submenu-collapse"
                      >
                        {row.childMenu.map((submenu, subIndex) => (
                          <Link
                            to={submenu.url}
                            key={subIndex}
                            className={`sidemenu--item ${activeUrl === submenu.url ? "active" : ""}`}
                          >
                            <ListItemButton
                              sx={{ minHeight: 44, pl: 2, pr: 2 }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: 1.5,
                                  justifyContent: "center",
                                }}
                              >
                                {submenu.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={submenu.title}
                                sx={{ "& span": { fontSize: "13px" } }}
                              />
                            </ListItemButton>
                          </Link>
                        ))}
                      </Collapse>
                    )}
                  </>
                ) : (
                  <Link
                    to={row.url}
                    key={index}
                    className={`sidemenu--item ${activeUrl === row.url ? "active" : ""}`}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        px: isSidebarOpen ? 2.5 : 0,
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <ListItemText
                          primary={row.title}
                          sx={{ whiteSpace: "nowrap" }}
                        />
                      )}
                    </ListItemButton>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </Grid>

          {/* ── MenuManagement ── */}
          <Grid>
            {MenuManagement.map((row, index) => (
              <React.Fragment key={index}>
                {row.childMenuFlag ? (
                  <>
                    <ListItemButton
                      className={`menu_id ${selectedIndex - 1 === index ? "active" : ""}`}
                      onClick={() => handleClick(index + generalMenu.length)}
                      sx={{
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        px: isSidebarOpen ? 2.5 : 0,
                        minHeight: 48,
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <>
                          <ListItemText
                            primary={row.title}
                            sx={{ whiteSpace: "nowrap" }}
                          />
                          {index + generalMenu.length === selectedIndex ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </>
                      )}
                    </ListItemButton>
                    {isSidebarOpen && (
                      <Collapse
                        in={index + generalMenu.length === selectedIndex}
                        timeout="auto"
                        unmountOnExit
                        className="submenu-collapse"
                      >
                        {row.childMenu.map((submenu, subIndex) => (
                          <Link
                            to={submenu.url}
                            state={{ parentKey: row.key }}
                            key={subIndex}
                            className={`sidemenu--item ${isSubmenuActive(row, submenu) ? "active" : ""}`}
                          >
                            <ListItemButton
                              sx={{ minHeight: 44, pl: 2, pr: 2 }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: 1.5,
                                  justifyContent: "center",
                                }}
                              >
                                {submenu.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={submenu.title}
                                sx={{ "& span": { fontSize: "13px" } }}
                              />
                            </ListItemButton>
                          </Link>
                        ))}
                      </Collapse>
                    )}
                  </>
                ) : (
                  <Link
                    to={row.url}
                    key={index}
                    className={`sidemenu--item ${activeUrl === row.url ? "active" : ""}`}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        px: isSidebarOpen ? 2.5 : 0,
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <ListItemText
                          primary={row.title}
                          sx={{ whiteSpace: "nowrap" }}
                        />
                      )}
                    </ListItemButton>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </Grid>
        </>
      ) : (
        <></>
      )}

      {userData.role_id === 36 ? (
        <Grid>
          {UserMenu.map((row, id) =>
            row.childMenuFlag ? (
              <React.Fragment key={id}>
                <ListItemButton
                  className="menu_id"
                  onClick={() => handleClick(id)}
                  sx={{
                    justifyContent: isSidebarOpen ? "flex-start" : "center",
                    px: isSidebarOpen ? 2.5 : 0,
                    minHeight: 48,
                    width: "100%",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSidebarOpen ? 2 : 0,
                      justifyContent: "center",
                    }}
                  >
                    {row.icon}
                  </ListItemIcon>
                  {isSidebarOpen && (
                    <>
                      <ListItemText
                        primary={row.title}
                        sx={{ whiteSpace: "nowrap" }}
                      />
                      {id === selectedIndex ? <ExpandLess /> : <ExpandMore />}
                    </>
                  )}
                </ListItemButton>
                {isSidebarOpen && (
                  <Collapse
                    in={id === selectedIndex}
                    timeout="auto"
                    unmountOnExit
                    className="submenu-collapse"
                  >
                    {row.childMenu.map((submenu, subId) => (
                      <Link
                        to={submenu.url}
                        key={subId}
                        className={`sidemenu--item ${activeUrl === "" + submenu.url ? "active" : ""}`}
                      >
                        <ListItemButton sx={{ minHeight: 44, pl: 2, pr: 2 }}>
                          <ListItemText primary={submenu.title} />
                        </ListItemButton>
                      </Link>
                    ))}
                  </Collapse>
                )}
              </React.Fragment>
            ) : (
              <Link
                to={row.url}
                key={id}
                className={`sidemenu--item ${activeUrl === "" + row.url ? "active" : ""}`}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    px: isSidebarOpen ? 2.5 : 0,
                    justifyContent: isSidebarOpen ? "flex-start" : "center",
                    width: "100%",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSidebarOpen ? 2 : 0,
                      justifyContent: "center",
                    }}
                  >
                    {row.icon}
                  </ListItemIcon>
                  {isSidebarOpen && (
                    <ListItemText
                      primary={row.title}
                      sx={{ whiteSpace: "nowrap" }}
                    />
                  )}
                </ListItemButton>
              </Link>
            ),
          )}
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}
export default Sidenav;
